import moment from 'moment';
import { FiltroSelecionado } from './models/filtro-selecionado.model';

/** Filtro enviado à API; o SQL é montado no servidor, só com as colunas configuradas do relatório. */
export interface FiltroRelatorioApi {
    propriedade: string;
    condicao: string;
    termo: string | null;
    composicao: string | null;
}

/**
 * Converte os filtros do componente para a API. Datas do datepicker vão como yyyy-MM-dd (dia local),
 * para o servidor não depender do fuso da serialização.
 */
export const filtrosRelatorioApi = (filtros: FiltroSelecionado[] | null): FiltroRelatorioApi[] =>
    (filtros ?? []).map(filtro => ({
        propriedade: filtro.propriedade,
        condicao: filtro.condicao,
        termo: termoApi(filtro.termo),
        composicao: filtro.composicao ?? null,
    }));

const termoApi = (termo: unknown): string | null => {
    if (termo === null || termo === undefined) {
        return null;
    }

    if (termo instanceof Date || moment.isMoment(termo)) {
        return moment(termo).format('YYYY-MM-DD');
    }

    return String(termo);
};
